import React from "react";
import { useState } from "react";
import { TakeFiveSection } from "./TakeFiveSection";
import { takeFive } from "./TakeFivePageSelector";
import { TakeFiveView } from "./TakeFiveView";

export const TakeFiveSectionTakeFive = () => {

    return (
        <TakeFiveSection
            page={takeFive}
            pageView={TakeFiveView.TakeFive}
        />
    );
};